/**
 * Session length for the feedback payload: seconds since this tab's first
 * paint, tracked via sessionStorage so it survives client-side navigation but
 * resets on a fresh tab or reload. Everything is wrapped; sessionStorage can
 * throw in locked-down contexts and losing session length is not worth losing
 * feedback over.
 */

const STORAGE_KEY = 'billing_feedback_started_at';

export function markSessionStart(): void {
  try {
    if (!window.sessionStorage.getItem(STORAGE_KEY)) {
      window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
  } catch {
    /* no sessionStorage: getSessionSeconds will read as 0 */
  }
}

/** Seconds since this tab's first paint, or 0 if unknown. */
export function getSessionSeconds(): number {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return 0;
    const started = Number(raw);
    if (!Number.isFinite(started) || started <= 0) return 0;
    return Math.max(0, Math.round((Date.now() - started) / 1000));
  } catch {
    return 0;
  }
}

/** Test seam. */
export function __resetSessionForTests(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
